import React, { createContext, useContext, useState, useEffect } from "react";
import { fetchQuery } from "react-relay";
import environment from "../../environment";
import { graphql } from "babel-plugin-relay/macro";

export const LogJobDataContext = createContext<any>(null);

const getLogJobDataQuery = graphql`
  query LogJobDataProviderQuery($isRegionalManager: Boolean) {
            getLocationList {
              id
              uuid
              name
            }
            getMachineList {
              id
              uuid
              serialNumber
              name
              locationId
            }
            getUsers(isRegionalManager: $isRegionalManager) {
              id
              firstName
              lastName
              isActive
              isRegionalManager
            }
            getMarketingMaterials {
              id
              name
              priority
            }
            getLocationTypes {
              id
              name
              description
              isDefault
            }
          }
`;

export const LogJobDataProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [data, setData] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<any>(null);

  useEffect(() => {
    fetchQuery(environment, getLogJobDataQuery, { isRegionalManager: true })
      .toPromise()
      .then((response) => {
        setData(response);
        setLoading(false);
      })
      .catch((err) => {
        setError(err);
        setLoading(false);
      });
  }, []);

  return (
    <LogJobDataContext.Provider value={{ data : data ?? {}, loading, error }}>
      {children}
    </LogJobDataContext.Provider>
  );
};

export const useLogJobData = () => useContext(LogJobDataContext);